module.exports = __webpack_public_path__ + "img/line-chart.2effa0f8.svg";